// Preview flag for the redesigned nav rail + top bar.
//
// This exists purely so the new nav/top-bar can be previewed next to the
// current ones and reverted with a single switch. Nothing else depends on
// it. To retire the experiment, delete this folder and the two v-if branches
// in App.vue.
//
// The value persists in localStorage and can be forced via a `?redesign=1`
// (or `?redesign=0`) query param on any URL.
import { ref } from "vue";

// Master switch for the whole preview. While false the redesigned nav/top-bar
// never render and the floating toggle is hidden — the components stay in the
// tree, dormant. Flip to true to bring the preview (and its toggle) back.
export const PREVIEW_ENABLED = false;

const KEY = "uiRedesign";

function initialValue() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("redesign")) {
      const on = params.get("redesign") === "1";
      localStorage.setItem(KEY, on ? "1" : "0");
      return on;
    }
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export const redesignEnabled = ref(PREVIEW_ENABLED && initialValue());

export function setRedesign(value) {
  redesignEnabled.value = !!value;
  try {
    localStorage.setItem(KEY, value ? "1" : "0");
  } catch {
    // localStorage unavailable — in-memory value still applies for the session
  }
}

export function toggleRedesign() {
  setRedesign(!redesignEnabled.value);
}
